import { render, staticRenderFns } from "./resourceList.vue?vue&type=template&id=c9945ce0&"
import script from "./resourceList.vue?vue&type=script&lang=js&"
export * from "./resourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports